module.exports = __webpack_public_path__ + "img/support_call.7ba09508.svg";